module.exports = __webpack_public_path__ + "img/tcApi_result_wait.c0c637ed.png";